module.exports = __webpack_public_path__ + "0644283900faca946e180c6672d3495d.svg";